import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Title from '../common/Title';
import DepartmentTags from '../parts/DepartmentTags';
import CallAnalysisTags from '../parts/CallAnalysisTags';

const styles = () => ({
  root: {
    background: '#F4F6F9',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    padding: '25px 25px 20px 25px',
    boxSizing: 'border-box',
  },
});

class DepartmentSection extends React.Component {
  render() {
    const { classes, executiveListItem, enableExecutiveListAdvancedSearch } = this.props;

    return (
      <div className={classes.root}>
        <Title title="部門" color="light" style={{ marginTop: '0px'}} />
        {executiveListItem && executiveListItem.department_keys && (
          <DepartmentTags
            departmentKeys={executiveListItem.department_keys}
          />
        )}
        {/* 一旦件数が少ない場合やオプションの制限など加味してオペレーターのみで表示させる */}
        {enableExecutiveListAdvancedSearch && executiveListItem && executiveListItem.call_analyses && (
          <CallAnalysisTags
            callAnalyses={executiveListItem.call_analyses}
          />
        )}
      </div>
    );
  }
}

DepartmentSection.propTypes = {
  classes: PropTypes.object.isRequired,
  executiveListItem: PropTypes.object,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
};

DepartmentSection.defaultProps = {
  executiveListItem: null,
  enableExecutiveListAdvancedSearch: false,
};

export default withStyles(styles)(DepartmentSection);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/DepartmentSection.jsx